import { render, staticRenderFns } from "./setorandeposito.vue?vue&type=template&id=d8ec1b78&scoped=true"
import script from "./setorandeposito.vue?vue&type=script&lang=js"
export * from "./setorandeposito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ec1b78",
  null
  
)

export default component.exports